import { Input } from '~/primitives/input';
import { useFieldContext } from '~/util/hooks/useFormContext';
import { FieldLabelWithError } from './FieldLabelWithError';
import type { FieldWithErrorProps } from './FieldLabelWithError';
import { cn } from '~/util';
import { useDisableFormContext } from '../DisableContext';
import Search from '~/partials/Search';

export function TextField({
    placeholder,
    classname,
    ...labelProps
}: {
    placeholder: string;
    classname?: string;
} & FieldWithErrorProps) {
    const field = useFieldContext<string | null>();
    const disabled = useDisableFormContext();
    return (
        <FieldLabelWithError<string | null> {...labelProps}>
            <Input
                className={cn('field-sizing-content max-w-lg', classname)}
                id={field.name}
                placeholder={placeholder}
                type="text"
                required={labelProps.required}
                value={field.state.value ?? ''}
                onChange={(e) =>
                    field.handleChange(
                        e.target.value === '' ? null : e.target.value,
                    )
                }
                disabled={disabled}
            />
        </FieldLabelWithError>
    );
}

export function SearchField({
    searchClassName,
    searchInputClassName,
    ...labelProps
}: {
    placeholder: string;
    searchClassName?: string;
    searchInputClassName?: string;
} & FieldWithErrorProps) {
    const field = useFieldContext<string | null>();
    return (
        <FieldLabelWithError<string | null> {...labelProps}>
            <Search
                wrapperClassName={cn(
                    'field-sizing-content max-w-lg',
                    searchClassName,
                )}
                inputClassName={cn(
                    'w-full hover:bg-transparent',
                    searchInputClassName,
                )}
                initial_input={field.state.value ?? ''}
                onInputChange={(value: string) =>
                    field.handleChange(value === '' ? null : value)
                }
            />
        </FieldLabelWithError>
    );
}
